module.exports = __webpack_public_path__ + "img/individual-meter-gas-meter-sm.2466118b.svg";